import { css } from 'styled-system/css';

export const Styles = {
	main: css({
		_mars: {
			'& .bettypes': {
				padding: '0'
			},
			'& .bettypes__content': {
				padding: '6px',
				backgroundColor: 'var(--s800)',
			}
		}
	}),
}